import { http } from './http'
import { Pagination, PaginationParams } from './map'
import { User } from '../../common/models'

export interface IUser {
  id?: string
  firstName?: string
  lastName?: string
  phone?: string
  email?: string
  referralCode?: string
}

export interface CreateUserPayload {
  firstName: string
  lastName: string
  email: string
  phone: string
  password: string
  active: boolean
  userGroupId: string
}

export type TCustomPermissions = {
  permissionId: string
  view: boolean
  edit: boolean
}

export interface UpdateUserPayload {
  firstName: string
  lastName: string
  email: string
  phone: string
  password?: string | null
  active: boolean
  userGroupId: string

  customPermission: boolean
  customPermissions?: TCustomPermissions[]
}

export const searchUsersByPhone = async (phone: string, signal?: AbortSignal) =>
  http.get<IUser[]>('/operations/users/search', {
    params: {
      phone,
    },
    signal,
  })

export const searchUsersByEmail = async (email: string, signal?: AbortSignal) =>
  http.get<IUser[]>('/operations/users/search', {
    params: {
      email,
    },
    signal,
  })

export const getUsers = (params?: PaginationParams) =>
  http.get<Pagination<User>>('/operations/dashboard-users', {
    params,
  })

export const getUser = (id: string) =>
  http.get<User>(`/operations/dashboard-users/${id}`)

export const updateUser = (id: string, payload: UpdateUserPayload) =>
  http.put<User>(`/operations/dashboard-users/${id}`, payload)

export const createUser = (payload: CreateUserPayload) =>
  http.post<User>('/operations/dashboard-users', payload)
